<template>
    <el-row :gutter="20" type="flex">
      <el-col :span="8">
        <el-card class="main-card">
          <div slot="header" style="display: flex; align-items: center; justify-content: space-between">
            <div style="font-size: 20px; font-weight: bold">设备分类</div>
            <el-button style="float: right; padding: 3px 0" type="text" @click="openEdit(1,{})">新增一级分类</el-button>
          </div>

          <el-collapse accordion @change="handleCategoryChange" class="category-collapse">
            <el-collapse-item v-for="(item, index) in topCategories" :key="index" :title="item.name"
                               :name="item.id">
              <div v-if="item.child && item.child.length > 0" v-for="(obj) in item.child" style="display: flex; align-items: center; justify-content: space-between;">
                <div @click="handleSecondCategory(obj)">{{obj.name}}</div>
                <div style="display: flex;align-items: center;gap: 2px">
                  <div><el-button type="text" @click="openEdit(2,obj)">编辑</el-button></div>
                  <!-- <div><el-button type="text">删除</el-button></div> -->
                </div>
              </div>
              <el-divider />
              <el-row :gutter="10" type="flex" style="box-sizing: border-box">
                <el-button type="text" size="mini" style="width: 20%" @click="openEdit(1,item)">{{ `编辑【${item.name}】` }}</el-button>
                <el-button type="primary" size="mini" round style="width: 70%" @click="openEdit(2)">{{ `新增【${item.name}】二级分类` }}</el-button>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-card>
        <el-dialog :visible.sync="topVisible" width="500px">
          <div v-if="selectedLevel === 2" style="margin-bottom: 20px;">上级分类: {{this.categoryPath.one.name}}</div>
          <el-form :rules="topCategoryRules" ref="topCategoryRef" :model="topCategoryForm" label-width="80px" >
            <el-form-item label="分类名称" prop="name">
              <el-input v-model="topCategoryForm.name" placeholder="请输入类别名称" maxlength="50" show-word-limit clearable />
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input-number v-model="topCategoryForm.sort" placeholder="请输入排序" maxlength="50" show-word-limit clearable />
            </el-form-item>
            <div style="display: flex; justify-content: flex-end; gap: 6px">
              <el-button type="primary" @click="handleTopCategorySave">保存</el-button>
              <el-button @click="topVisible = false">取消</el-button>
            </div>
          </el-form>
        </el-dialog>
      </el-col>
      <el-col :span="16">
        <div>
          <!-- 页面标题 -->
          <!-- <div class="page-header">
        <h2>系统管理</h2>
        <p>管理所有物联网系统及相关信息</p>
      </div> -->

          <el-card class="main-card">
            <div slot="header" style="display: flex;align-items: center;justify-content: space-between;">
                <div style="width: 200px">
                  <el-input size="mini" placeholder="请输入设备类型名称" style="margin-right: 20px;" v-model="searchKeyword" @input="handleSearch" />
                </div>
                <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAddDevice">
                  添加类型
                </el-button>
            </div>
            <div style="display: flex;align-items: center; gap: 2px; font-size: 13px;margin:0 20px 20px 20px;">
              <div @click="defaultAll">全部</div>
              <div v-if="categoryPath.one"><i class="el-icon-arrow-right" />{{ categoryPath.one.name }}</div>
              <div v-if="categoryPath.two"><i class="el-icon-arrow-right" />{{ categoryPath.two.name }}</div>
            </div>


            <!-- 系统表格 -->
            <el-table :data="devices" border class="device-table" stripe highlight-current-row
                      :row-class-name="tableRowClassName">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="id" label="类型id"></el-table-column>
              <!-- <el-table-column prop="code" label="系统编码" width="230"></el-table-column> -->
              <el-table-column prop="name" label="设备类型名称"></el-table-column>
              <el-table-column prop="abbreviation" label="编码"></el-table-column>
              <el-table-column label="操作" width="240" fixed="right">
                <template slot-scope="scope">

                  <el-button size="mini" type="text" @click="handleEditDevice(scope.row)"
                             class="operation-btn edit-btn">
                    编辑
                  </el-button>
                  <el-button size="mini" type="text" @click="handleDeleteDevice(scope.row.id)"
                             class="operation-btn delete-btn">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                             :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                             layout="total, sizes, prev, pager, next, jumper" :total="total" class="pagination"></el-pagination>
            </div>
          </el-card>

          <!-- 新增系统信息弹窗 -->
          <el-dialog title="新增类别信息" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false"
                     :destroy-on-close="true" custom-class="custom-dialog">
            <el-form ref="deviceFormSys" :model="deviceFormSys" :rules="rulestytem" label-width="120px"
                     class="device-form">
              <el-form-item label="上级分类" prop="topCategoryId">
                <el-cascader
                    :options="topCategories"
                    :props="{
                      label: 'name',
                      value: 'id',
                      children: 'child'
                    }"
                    @change="handleChangeTop" />
              </el-form-item>

              <!-- 系统名称 -->
              <el-form-item label="类型名称" prop="name">
                <el-input v-model="deviceFormSys.name" placeholder="请输入类型名称" maxlength="50" show-word-limit
                          class="form-input"></el-input>
              </el-form-item>

              <el-form-item label="类型编码" prop="abbreviation">
                <el-input v-model="deviceFormSys.abbreviation" placeholder="请输入类型编码" maxlength="50" show-word-limit
                          class="form-input"></el-input>
              </el-form-item>

              <el-form-item label="设备图片">
                <el-upload class="upload-demo" action="" :http-request="customUpload" :on-preview="handlePreview"
                           :on-remove="handleRemove" list-type="picture">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件,且不超过500kb</div>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false" class="dialog-btn cancel-btn">取消</el-button>
              <el-button type="primary" @click="handleSave" class="dialog-btn confirm-btn">保存</el-button>
            </div>
          </el-dialog>



          <!-- 修改系统信息弹窗 -->
          <el-dialog title="编辑类别信息" :visible.sync="dialogVisibleEdit" width="500px" :close-on-click-modal="false"
                     :destroy-on-close="true" custom-class="custom-dialog">
            <el-form ref="deviceFormSysEdit" :model="deviceFormSysEdit" :rules="rulestytem" label-width="120px"
                     class="device-form">
              <!-- 系统名称 -->
              <el-form-item label="类型名称" prop="name">
                <el-input v-model="deviceFormSysEdit.name" placeholder="请输入类型名称" maxlength="50" show-word-limit
                          class="form-input"></el-input>
              </el-form-item>
              <el-form-item label="类型编码" prop="abbreviation">
                <el-input v-model="deviceFormSysEdit.abbreviation" placeholder="请输入类型编码" maxlength="50"
                          show-word-limit class="form-input"></el-input>
              </el-form-item>
              <el-form-item label="设备图片">
                <el-upload class="upload-demo" action="" :http-request="customUpload" :on-preview="handlePreview"
                           :on-remove="handleRemove" list-type="picture" :file-list="fileList">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件,且不超过500kb</div>
                </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="closeEditDialog" class="dialog-btn cancel-btn">取消</el-button>
              <el-button type="primary" @click="handleSaveEdit" class="dialog-btn confirm-btn">保存</el-button>
            </div>
          </el-dialog>


        </div>

      </el-col>
    </el-row>
</template>

<script>
// import { systemList, addCategory, delCategory } from '@/api/system'
import {
  categoryPage,
  updoadImg,
  addCategory,
  delCategory,
  categoryDetail,
  topCategory,
  saveTopCategory, updateTopCategory
} from '@/api/index'
export default {
    name: 'DeviceList',
    data() {
        return {
            fileList: [],
            selectedIds: [], // 绑定“选中的传感器id”的数组
            counts: {}, // 存储“每个传感器对应的数量”的对象
            radio: '1',
            searchKeyword: '',
            deviceStatus: '',
            deviceType: '',
            currentPage: 1,
            pageSize: 10,
            total: 0,
            dialogVisible: false,
            dialogVisibleEdit: false,
            searchKeywordCode: "",
            deviceequipmentTypes: [],
            uploadFileObj: null,
            // 系统表单数据
            deviceForm: {
                name: '',
                code: '',
                type: ''
            },
            deviceFormSysEdit: {
                name: "",
                uploadFile: "",
                abbreviation: ""
            },
            deviceFormSys: {
                name: "",
                uploadFile: "",
                abbreviation: ""
            },
            devices: [],
            // 系统类型选项
            deviceTypes: [],
            // 表单验证规则
            rulestytem: {
                name: [
                    { required: true, message: '请输入类型名称', trigger: 'blur' },
                    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
                ],
                abbreviation: [
                    { required: true, message: '请输入类型编码', trigger: 'blur' },
                    { pattern: /^[A-Za-z0-9_-]+$/, message: '编码只能包含字母、数字、下划线和横线', trigger: 'blur' }
                ]
            },
            selectedLevel : null,
            topCategories : [],
            topCategoryForm: {},
            topVisible : false,
            topCategoryRules: {
                name: [
                    { required: true, message: '请输入类别名称', trigger: 'blur' },
                    { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
                ],
            },
            categoryPath : {
              one : null,
              two : null,
            },
            filterTopCategory: [],
        }
    },
    watch: {
        // 监听选中id的变化，初始化/清理数量
        selectedIds(newVal, oldVal) {
            // 新增选中项：初始化数量为1（确保响应式，用$set）
            newVal.forEach(id => {
                if (!this.counts[id]) {
                    this.$set(this.counts, id, 1);
                }
            });
            // 取消选中项：删除对应数量（可选，若需保留可注释）
            oldVal.forEach(id => {
                if (!newVal.includes(id)) {
                    this.$delete(this.counts, id);
                }
            });
        }
    },
    computed: {
        // 过滤系统列表 - 优化搜索逻辑
        filteredDevices() {
            // 如果没有搜索关键词，直接返回所有系统
            if (!this.searchKeyword) {
                return [...this.devices];
            }
            const keyword = this.searchKeyword.toLowerCase();
            return this.devices.filter(device => {
                // 确保系统名称和编码存在，避免undefined错误
                const nameMatch = device.name
                    ? device.name.toLowerCase().includes(keyword)
                    : false;
                const codeMatch = device.code
                    ? device.id.toLowerCase().includes(keyword)
                    : false;
                return nameMatch || codeMatch;
            })
        },
        // 分页处理
        pagedDevices() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            return this.filteredDevices.slice(startIndex, endIndex);
        }
    },
    mounted() {
        this.systemInfo();
        this.fetchTopCategory();
        // this.categoryList(); // 提前加载系统类型
    },
    methods: {
        handleCategoryChange(e){
          const top = this.topCategories.filter(f => f.id === e)[0]
          this.categoryPath.one = {
            id: top.id,
            name: top.name,
            child : top.child
          }
          this.categoryPath.two = null
          if (top.child && top.child.length > 0){
            this.filterTopCategory = top.child.map(item => item.id)
          }
          this.clearCategory();
          this.systemInfo();
        },
        handleSecondCategory(item){
          this.categoryPath.two = {
            id: item.id,
            name: item.name,
          }
          this.filterTopCategory = [item.id]

          this.clearCategory();
          this.systemInfo();
        },

        openEdit(level,data){
          this.topVisible = true;
          this.selectedLevel = level;
          if (data){
            this.topCategoryForm = {
              ...data
            }
          }
        },

        async fetchTopCategory() {
          topCategory().then(res => {
              if (res && res.code === "0000"){
                this.topCategories = res.result || []
              }
            })
        },

        defaultAll(){
          this.categoryPath =  {
            one : null,
            two : null,
          }
          this.filterTopCategory = []
          this.clearCategory();
          this.systemInfo();
        },

        clearCategory(){
          this.currentPage = 1
        },

        handleTopCategorySave(){
          this.$refs.topCategoryRef.validate(async (valid) => {
            if (valid){
                const param = {
                  ...this.topCategoryForm
                }
                if (param.id){
                  updateTopCategory(param).then(res => {
                    if (res && res.code === "0000"){
                      this.$message.success('操作成功')
                      this.topVisible = false;
                      this.clearCategory();
                      this.filterTopCategory = []
                      this.fetchTopCategory().then(res => this.systemInfo())
                    }
                  })
                }else {
                  if (this.selectedLevel === 1){
                    param.parentId = 0
                    param.level = 1
                  }else if (this.selectedLevel === 2){
                    param.parentId = this.categoryPath.one.id
                    param.level = 2
                  }
                  saveTopCategory(param).then(res => {
                    if (res && res.code === "0000"){
                      this.$message.success('操作成功')
                      this.topVisible = false;
                      this.clearCategory();
                      this.filterTopCategory = []
                      this.fetchTopCategory().then(res => this.systemInfo())
                    }
                  })
                }

            }
          })


        },

        handleChangeTop(e){
          this.deviceFormSys.topCategoryId = e[1]
        },


        handleRemove(file, fileList) {
            this.uploadFileObj = null;
            console.log(file, fileList);
        },
        handlePreview(file) {
            console.log(file);
        },


        //上传图片
        async customUpload(params) {
            const formData = new FormData();
            formData.append('file', params.file);  // 关键：将文件添加到 FormData
            try {
                const res = await updoadImg(formData);  // 传入 FormData
                this.uploadFileObj = res.result
                console.log("上传成功", res);
                params.onSuccess(res);  // 通知 el-upload 上传成功
            } catch (err) {
                console.error("上传失败", err);
                params.onError(err);  // 通知 el-upload 上传失败
            }
        },




        // 为表格行添加交替样式
        tableRowClassName({ row, rowIndex }) {
            return rowIndex % 2 === 0 ? 'table-row-even' : 'table-row-odd';
        },


        generateSubmitData() {
            // 遍历选中的ID，映射成后端需要的格式
            this.equipmentTemplateSensorList = this.selectedIds.map((sensorTypeId, index) => {
                return {
                    sensorTypeId: Number(sensorTypeId), // 传感器ID
                    sensorNum: Number(this.counts[sensorTypeId]), // 对应的数量
                    sort: index + 1
                };
            });
        },



        //删除系统
        handleDeleteDevice(id) {
            this.$confirm('确定要删除该系统吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await delCategory(id)
                if (res.code == "0000") {
                    this.$message.success('系统删除成功')
                    this.currentPage = 1
                    this.pageSize = 10
                    this.systemInfo()
                }
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },



        //新增系统保存
        async handleSave() {
            let list = {
                abbreviation: this.deviceFormSys.abbreviation,
                name: this.deviceFormSys.name,
                uploadFile: this.uploadFileObj,
                topCategoryId: this.deviceFormSys.topCategoryId
            }
            const res = await addCategory(list)
            if (res.code == "0000") {
                this.$message.success('添加类型成功')
                this.systemInfo()
                this.dialogVisible = false;
            }
        },


        //保存编辑的信息
        async handleSaveEdit() {
            let list = {
                id: this.deviceFormSysEdit.id,
                abbreviation: this.deviceFormSysEdit.abbreviation,
                name: this.deviceFormSysEdit.name,
                uploadFile: this.uploadFileObj,
              topCategoryId: this.deviceFormSysEdit.topCategoryId
            }
            // console.log("list",list)
            // return;
            const res = await addCategory(list)
            if (res.code == "0000") {
                this.$message.success('修改设备成功')
                this.systemInfo()
                this.dialogVisibleEdit = false;
            }
        },


        handleEditDialogClose() {
            this.selectedIds = [];  // 清空传感器选中状态
            this.counts = {};       // 清空传感器数量
            this.radio = "1";       // 重置启用状态为默认值
            // 重置表单（避免下次打开残留旧数据）
            if (this.$refs.deviceFormEdit) {
                this.$refs.deviceFormEdit.resetFields();
            }
        },




        //点击修改系统信息弹框
        async handleEditDevice(item) {
            this.fileList = []
            const res = await categoryDetail(item.id)
            let info = res.result
            let imageUrls = info.uploadFile
            if (imageUrls){
              this.uploadFileObj = imageUrls
              // console.log("imageUrls",res)
              // 注意：如果 imageUrls 可能是数组（多个图片），需要循环处理
              let imgOjb = {
                  name: imageUrls.fileName,
                  url: imageUrls.urlPath + imageUrls.urlHttp,
                  uid: `edit-${Date.now()}` // 补充唯一标识，避免 el-upload 出现异常
              }
              // 直接 push 到数组，不要赋值
              this.fileList.push(imgOjb)
            }
            // 其他赋值逻辑...
            this.deviceFormSysEdit.name = info.name
            this.deviceFormSysEdit.abbreviation = info.abbreviation
            this.deviceFormSysEdit.id = info.id
            this.deviceFormSysEdit.topCategoryId = item.topCategoryId;
            this.dialogVisibleEdit = true;
        },


        closeEditDialog() {
            this.fileList = []
            this.dialogVisibleEdit = false
        },


        //系统列表接口
        async systemInfo() {
            try {
                let list = {
                    "filter": [
                        {
                            "name": "name",
                            "value": this.searchKeyword,
                            "type": "LIKE"
                        }
                    ],
                    current: this.currentPage,
                    size: this.pageSize,
                }

                if (this.filterTopCategory.length > 0) {
                    list.filter.push({
                        "name": "topCategoryId",
                        "value": this.filterTopCategory,
                        "type": "IN"
                    })
                }
                const res = await categoryPage(list)
                this.devices = res.result.records || []; // 确保有默认空数组
                this.total = res.result.total;
            } catch (error) {
                console.error(error)
                this.devices = []; // 出错时重置为空数组
            }
        },


        //传感器类型接口
        async sensorType() {
            try {
                const res = await sensorTypeList({});
                this.deviceTypes = res.result.records;
                // 如果类型不一致（比如一个是数字，一个是字符串），统一类型
                this.deviceTypes = this.deviceTypes.map(item => ({
                    ...item,
                    id: String(item.id) // 统一转为字符串（或Number，看device.categooryId类型）
                }));
                this.deviceFormEdit.type = String(this.deviceFormEdit.type); // 同步类型
            } catch (error) {
                console.error('获取传感器类型失败：', error);
                this.$message.error('加载传感器类型失败，请重试');
            }
        },

        //设备类型接口
        async categoryList() {
            try {
              const param = {
                current : 1,
                size : 1000
              }
                const res = await categoryInfo(param);
                this.deviceequipmentTypes = res.result.records;
                // 如果类型不一致（比如一个是数字，一个是字符串），统一类型
                this.deviceequipmentTypes = this.deviceequipmentTypes.map(item => ({
                    ...item,
                    id: String(item.id) // 统一转为字符串（或Number，看device.categooryId类型）
                }));
                // this.deviceFormEdit.type = String(this.deviceFormEdit.type); // 同步类型
            } catch (error) {
                console.error('获取系统类型失败：', error);
                this.$message.error('加载系统类型失败，请重试');
            }
        },

        // 搜索处理 - 重置页码并重新加载数据
        handleSearch() {
            this.currentPage = 1; // 搜索时重置到第一页
            this.systemInfo()
        },

        handleSizeChange(val) {
            this.pageSize = val;
            // this.currentPage = 1; // 当页面大小改变时，重置到第一页
            this.systemInfo()
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.systemInfo()
        },

        getTypeName(type) {
            const typeMap = {
                temperature: '温度传感器',
                humidity: '湿度传感器',
                switch: '智能开关',
                smoke: '烟雾报警器'
            }
            return typeMap[type] || '未知类型'
        },

        getTypeTagType(type) {
            const typeMap = {
                temperature: 'primary',
                humidity: 'success',
                switch: 'warning',
                smoke: 'info'
            }
            return typeMap[type] || 'default'
        },

        handleAddDevice() {
            this.deviceFormSys = { stytemType: '', orderNum: '' }; // 重置表单
            this.dialogVisible = true;
        },

        handleViewDetails(item) {
            this.$router.push({
                name: 'SensorList',
                query: {
                    id: item.id,
                    code: item.code,
                    name: item.name
                }
            })
        },
    }
}
</script>

<style scoped>
.sensor-item {
    display: flex;
    align-items: center;
    gap: 12px;
    /* Checkbox与数量控件的间距 */
    margin-bottom: 8px;
    /* 上下项间距 */
}

/* 调整数量控件宽度 */
.count-input {
    width: 120px;
}

/* 全局样式 */
.device-list-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

/* 页面标题 */
.page-header {
    margin-bottom: 24px;
}

.page-header h2 {
    font-size: 22px;
    color: #1f2937;
    margin-bottom: 8px;
    font-weight: 600;
}

.page-header p {
    font-size: 14px;
    color: #6b7280;
}

/* 主卡片样式 */
.main-card {
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: none;
    overflow: hidden;
    transition: all 0.3s ease;
}

.main-card:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}


.header-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
}

.add-btn {
    transition: all 0.2s ease;
}

.add-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}

/* 搜索区域 */
.filter-bar {
    display: flex;
    margin: 20px;
    align-items: center;
}

.search-input {
    width: 300px;
    height: 40px;
    border-radius: 6px;
    transition: all 0.3s ease;
}

.search-input:focus {
    border-color: #1890ff;
    box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
}

/* 表格样式 */
.device-table {
    margin: 0 20px;
    border-radius: 6px;
    overflow: hidden;
}

::v-deep .el-table th {
    background-color: #f7f8fa;
    font-weight: 500;
    color: #4b5563;
    padding: 12px 0;
}

::v-deep .el-table td {
    padding: 12px 0;
}

.table-row-even {
    background-color: #fff;
}

.table-row-odd {
    background-color: #fafafa;
}

::v-deep .el-table__row:hover>td {
    background-color: #f0f7ff !important;
}

::v-deep .el-table__current-row>td {
    background-color: #e6f7ff !important;
}

/* 操作按钮样式 */
.operation-btn {
    padding: 4px 8px;
    margin: 0 4px;
    border-radius: 4px;
    transition: all 0.2s ease;
}

.view-btn {
    color: #1890ff;
}

.view-btn:hover {
    background-color: rgba(24, 144, 255, 0.1);
}

.edit-btn {
    color: #52c41a;
}

.edit-btn:hover {
    background-color: rgba(82, 196, 26, 0.1);
}

.delete-btn {
    color: #ff4d4f;
}

.delete-btn:hover {
    background-color: rgba(255, 77, 79, 0.1);
}

/* 分页样式 */
.pagination-container {
    margin: 20px;
    padding-top: 15px;
    border-top: 1px solid #f0f2f5;
    text-align: right;
}

::v-deep .el-pagination {
    font-size: 14px;
}

::v-deep .el-pagination button,
::v-deep .el-pagination span:not([class*='suffix']) {
    height: 32px;
    line-height: 32px;
    min-width: 32px;
    border-radius: 4px;
}

::v-deep .el-pagination .el-pager li {
    margin: 0 3px;
    border-radius: 4px;
    width: 32px;
    height: 32px;
    line-height: 32px;
}

::v-deep .el-pagination .el-pager li.active {
    background-color: #1890ff;
    color: #fff;
}

/* 表单样式 */
.device-form {
    margin-top: 15px;
}

.form-input,
.form-select {
    width: 100%;
    border-radius: 6px;
    transition: all 0.3s ease;
}

.form-input:focus,
.form-select:focus {
    border-color: #1890ff;
    box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
}

/* 弹窗样式 */
::v-deep .custom-dialog {
    border-radius: 12px;
    overflow: hidden;
}

::v-deep .custom-dialog .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #f0f2f5;
    background-color: #f7f8fa;
}

::v-deep .custom-dialog .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
}

::v-deep .custom-dialog .el-dialog__body {
    padding: 20px;
}

::v-deep .custom-dialog .el-dialog__footer {
    padding: 12px 20px;
    border-top: 1px solid #f0f2f5;
}

.sonser-box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

::v-deep .el-checkbox__label {
    padding-left: 6px !important;
}

::v-deep .el-checkbox {
    padding-right: 10px;
}

/* 弹窗按钮 */
.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.dialog-btn {
    padding: 8px 16px;
    border-radius: 6px;
    transition: all 0.2s ease;
}

.cancel-btn {
    background-color: #f5f5f5;
    color: #4b5563;
    border-color: #e0e0e0;
}

.cancel-btn:hover {
    background-color: #e9e9e9;
    color: #374151;
}

.confirm-btn {
    background-color: #1890ff;
    border-color: #1890ff;
}

.confirm-btn:hover {
    background-color: #0f7ae5;
    border-color: #0f7ae5;
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}

/* 优化表单项间距 */
::v-deep .el-form-item {
    margin-bottom: 20px;
}

/* 响应式适配 */
@media (max-width: 768px) {
    .device-list-container {
        padding: 10px;
    }

    .search-input {
        width: 100%;
    }

    .header-actions {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .pagination-container {
        text-align: center;
    }

    ::v-deep .el-table {
        font-size: 13px;
    }

    ::v-deep .el-table .el-table__cell {
        padding: 8px 0;
    }

    .operation-btn {
        padding: 2px 6px;
        font-size: 12px;
    }
}
</style>
